import { render } from "./TemplateDbsBookingConfirmation.vue?vue&type=template&id=7ef58bb0&scoped=true"
import script from "./TemplateDbsBookingConfirmation.vue?vue&type=script&lang=js"
export * from "./TemplateDbsBookingConfirmation.vue?vue&type=script&lang=js"

import "./TemplateDbsBookingConfirmation.vue?vue&type=style&index=0&id=7ef58bb0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7ef58bb0"

export default script